import { render, staticRenderFns } from "./firmantes.vue?vue&type=template&id=69458bb3"
import script from "./firmantes.vue?vue&type=script&lang=js"
export * from "./firmantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports